import { styled } from '@mui/material';
import { stepContainersAnimations } from '../animations';
import {
  getNodeWrapperStyles,
  getStepContainerStyles,
  getStepLabelContainerStyles,
  getStepsContainerStyles,
} from '../utils';

// Container for all steps
export const StepsContainer = styled('div')<{
  stepCount: number;
  stepSpacing: number;
}>(({ stepCount, stepSpacing, theme }) => ({
  ...getStepsContainerStyles(stepCount, stepSpacing, theme),
}));

// Container for individual step (node + label together)
export const StepContainer = styled('div')<{
  isFirst: boolean;
  isLast: boolean;
  stepIndex?: number;
  stepSpacing: number;
}>(({ isFirst, isLast, stepIndex = 0, stepSpacing, theme }) => ({
  ...getStepContainerStyles(stepIndex, stepSpacing, theme, isLast, isFirst),
  ...stepContainersAnimations,
}));

// Step label container with proper alignment
export const StepLabelContainer = styled('div')(() => ({
  ...getStepLabelContainerStyles(),
}));

// Individual node wrapper
export const NodeWrapper = styled('div')({
  ...getNodeWrapperStyles(),
});
